import { useCallback, useContext, useEffect, useRef } from "react";
import { updateSelectorDefaults } from "../actions/updateSelectorDefaults";
import { ConfigurationMaxDepthContext } from "../context/ConfigurationMaxDepthContext";
import { useConfigurationDispatch } from "../context/ConfigurationReduxContext";
import { ShowInactiveAttributesContext } from "../context/ShowInactiveAttributesContext";
import { ShowNotVisibleAttributesContext } from "../context/ShowNotVisibleAttributesContext";
/**
 * Returns a function to set current selector defaults
 * - used when starting or resuming the configuration
 *
 * Does not trigger an automatic refetch
 * @private
 * @category Hook
 * @returns
 */
export function useUpdateSelectorDefaults() {
    const dispatch = useConfigurationDispatch();
    const includeNotActive = useContext(ShowInactiveAttributesContext);
    const includeNotVisible = useContext(ShowNotVisibleAttributesContext);
    const maxDepth = useContext(ConfigurationMaxDepthContext);
    // ref prevents recreation of the callback
    const includeNotActiveRef = useRef(includeNotActive);
    const includeNotVisibleRef = useRef(includeNotVisible);
    const maxDepthRef = useRef(maxDepth);
    // update value of refs
    useEffect(() => {
        includeNotActiveRef.current = includeNotActive;
        includeNotVisibleRef.current = includeNotVisible;
        maxDepthRef.current = maxDepth;
    }, [includeNotActive, includeNotVisible, maxDepth]);
    return useCallback(() => {
        dispatch(updateSelectorDefaults({
            includeNotActive: includeNotActiveRef.current,
            includeNotVisible: includeNotVisibleRef.current,
            maxDepth: maxDepthRef.current,
        }));
    }, [dispatch]);
}
//# sourceMappingURL=useUpdateSelectorDefaults.js.map